import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Hero from "../components/hero";
import Contact from "../components/contact";
import About from "../components/about";
import { useInView } from "react-intersection-observer";

const IndexPage = () => {
  const [ref, inView] = useInView({
    rootMargin: "0px 0px -200px 0px",
  });

  return (
    <Layout inView={inView ?? false}>
      <Seo title="Home" />
      <Hero />
      <div ref={ref}>
        <About/>
        <Contact />
      </div>
    </Layout>
  );
};
export default IndexPage;
